import { getCurrentTimeInTimezone } from './timezone';

// Check if browser supports notifications
const isNotificationSupported = () => {
  return 'Notification' in window;
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

// Send a notification
export const sendNotification = (title, options = {}) => {
  if (!isNotificationSupported() || Notification.permission !== 'granted') {
    return;
  }

  const defaultOptions = {
    icon: '/favicon.ico', // You might want to update this with your app's icon
    badge: '/favicon.ico',
    silent: false,
    requireInteraction: false,
  };

  new Notification(title, { ...defaultOptions, ...options });
};

// Timer notification types
export const TimerNotifications = {
  STARTED: {
    title: 'Time Tracking Started',
    body: () =>
      `Your time tracking session has begun at ${getCurrentTimeInTimezone()}.`,
  },
  STOPPED: {
    title: 'Time Tracking Stopped',
    body: (duration) =>
      `Time tracking stopped at ${getCurrentTimeInTimezone()}. Total duration: ${duration}`,
  },
  CANCELLED: {
    title: 'Time Tracking Cancelled',
    body: () =>
      `Your time tracking session has been cancelled at ${getCurrentTimeInTimezone()}.`,
  },
  INTERVAL: {
    title: 'Time Tracking Update',
    body: (duration) =>
      `You've been tracking time for ${duration} (Current time: ${getCurrentTimeInTimezone()})`,
  },
  PUNCH_IN: {
    title: 'Punched In',
    body: () =>
      `You have punched in at ${getCurrentTimeInTimezone()}. Ready to track time!`,
  },
  PUNCH_OUT: {
    title: 'Punched Out',
    body: () =>
      `You have punched out at ${getCurrentTimeInTimezone()}. Work session ended.`,
  },
};
